import React, { useState, useEffect } from 'react';
import { useDataProvider, useRedirect } from "react-admin";
import { MemberBox } from '@logora/parliament.parliament_member.member_box';
import { Box } from '@logora/parliament.ui.box';
import styles from "./CommissionMixteParitaire.module.scss";


export const CMPComposition = ({ acteLegislatif, date }) => {
    const [mandats, setMandats] = useState([]);
    const dataProvider = useDataProvider();
    const redirectTo = useRedirect();

    useEffect(() => {
        const fetchMandat = async () => {
            try {
                const response = await dataProvider.getList("mandats", {
                    filter: { organeRefUid: acteLegislatif.organeRefUid, nominPrincipale: true },
                    include: ["acteurRef.groupeParlementaire"],
					pagination: { perPage: 100 },
                });
                const mandats = response.data;

                if (mandats?.length > 0) {
                    const uniqueMandats = mandats.reduce((acc, mandat) => {
                        const existingMandat = acc.find(m => m.acteurRefUid === mandat.acteurRefUid);
                        if (!existingMandat || (existingMandat.codeQualite === "Suppléant" || existingMandat.codeQualite === "Titulaire")) {
                            return [...acc.filter(m => m.acteurRefUid !== mandat.acteurRefUid), mandat];
                        }
                        return acc;
                    }, []);

                    const sortedMandats = uniqueMandats.sort((a, b) => {
                        const priority = { Président: 1, "Vice-Président": 2, Rapporteur: 3, Titulaire: 4, Suppléant: 5 };
                        return (priority[a.codeQualite] || 0) - (priority[b.codeQualite] || 0);
                    });

                    setMandats(sortedMandats);
                }

            } catch (error) {
                console.log(error);
            }
        };

        fetchMandat();
    }, []);

    if (mandats.length === 0) {
        return <div className={styles.noMandat}>Aucun mandat trouvé</div>;
    }

    return (
        <Box title={"Composition"} className={styles.compositionWrapper}>
            <div className={styles.compositionContainer}>
                {mandats.map((mandat) => (
                    <div key={mandat.uid} className={styles.commissionMember}>
                        <MemberBox
                            firstName={mandat?.acteurRef?.prenom}
                            lastName={mandat?.acteurRef?.nom}
                            imageUrl={mandat?.acteurRef?.urlImage}
                            parliamentGroup={{
                                color: mandat?.acteurRef?.groupeParlementaire?.couleurAssociee,
                                groupName: mandat?.acteurRef?.groupeParlementaire?.libelleAbrege,
                            }}
                            layout="stacked"
                            onClick={() =>
                                redirectTo(`/parliament/acteurs/${mandat?.acteurRefUid}`)
                            }
                        />
                        <p>{mandat.codeQualite}</p>
                    </div>
                ))}
            </div>
        </Box>
    );
};